// Cross-app wire contract: the query param that carries the visitor id during
// a web -> app handoff. Storage key names are intentionally NOT here; they are
// private to each host's storage adapter.
export const BP_VISITOR_ID_PARAM = "bp_vid";
